import { Component, OnInit,Input,DoCheck } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.css']
})
export class DeviceComponent implements OnInit,DoCheck {
  @Input() info: string = ""; //组件传入id 用于获取当前ticket信息
  isShowInfo:boolean = false;
  isMobile:boolean = this.commonService.IsMobile();
  deviceInfo:any = {

  };
  constructor(private commonService: CommonService,) { }
  ngOnInit(): void {
  }
  ngDoCheck(): void {
    this.deviceInfo =  this.info && JSON.parse(this.info) || {};
  }
}
